"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var form_card_model_1 = require("../layout-models/form-models/form-card.model");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
require("./form-card-settings.component.scss");
var FormCardSettingsComponent = /** @class */ (function () {
    function FormCardSettingsComponent(languageService, currentLanguageProvider) {
        this.languageService = languageService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.isReady = false;
        this._onCloseEmitter = new core_1.EventEmitter();
    }
    Object.defineProperty(FormCardSettingsComponent.prototype, "onClose", {
        get: function () {
            return this._onCloseEmitter;
        },
        enumerable: true,
        configurable: true
    });
    FormCardSettingsComponent.prototype.ngOnInit = function () {
        var languages$ = this.languageService.getAvailableLanguages();
        var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
        this.languageSettings$ = zip_1.zip(languages$, currentLanguage$).pipe(operators_1.map(function (data) { return ({
            languages: data[0],
            currentLanguage: data[1],
        }); }));
    };
    FormCardSettingsComponent.prototype.close = function () {
        this._onCloseEmitter.emit(true);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", form_card_model_1.FormCardModel)
    ], FormCardSettingsComponent.prototype, "card", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter),
        __metadata("design:paramtypes", [])
    ], FormCardSettingsComponent.prototype, "onClose", null);
    FormCardSettingsComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'form-card-settings',
            template: require('./form-card-settings.component.html'),
        }),
        __metadata("design:paramtypes", [idm_message_language_service_client_js_1.LanguageService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], FormCardSettingsComponent);
    return FormCardSettingsComponent;
}());
exports.FormCardSettingsComponent = FormCardSettingsComponent;
//# sourceMappingURL=form-card-settings.component.js.map